import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../i18n';

import { actions, Extension } from '../../../entities/rates';
import * as fromExtensions from '../../../entities/rates/selectors/extensions.selectors';

import { Insurance } from './insurance';
import { H2 } from '../../page';

export const ExtensionsContainer = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation('rates');

  useEffect(() => {
    dispatch(actions.fetchExtensions());
  }, []);

  const extensions: Record<string, Extension> = useSelector(fromExtensions.getExtensions) as never;

  return (
    <>
      {extensions && (
        <H2>
          <b>{t('rates.extension.title')}</b>
        </H2>
      )}

      {extensions && extensions.insurance && <Insurance insurance={extensions.insurance} />}
    </>
  );
};
